import { resource } from '../api'

/**
 * Upload files to s3
 * @param {Array} files
 */
const uploadFiles = ({ user, files, typeUpload, companyType, companyToken }) => {
  const formData = new FormData()
  const dataBody = {
    companyType: companyType,
    companyToken: companyToken,
    typeUpload: typeUpload,
    user: user,
  }
  formData.append('data', JSON.stringify(dataBody))
  files.forEach(it => {
    formData.append('files', it.file)
  })
  return resource
    .uploadFiles(formData)
    .then(({ data, status }) => {
      return data.attachments
    })
    .catch(({ status, response = {}, message }) => {
      const error = response.data || message

      throw new Error(error.type || status === 413 ? 'file-too-big' : 'upload-file-error')
    })
}

export default uploadFiles
